import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-polyglot'
import Tooltip from '@tippy.js/react'
import Mousetrap from 'mousetrap'
import { BrowserView } from 'react-device-detect'
import history from 'configureHistory'

import {
	FlexContainer,
	ShortcutModal,
	ButtonGroup,
	Button,
	Icon,
} from 'components'
import { getShortcutString } from 'components/Shortcut'

class PageFooterActions extends PureComponent {
	constructor(props) {
		super(props)

		this.state = {
			shortcutModalOpen: false,
		}
	}

	componentDidMount() {
		Mousetrap(document.querySelector('body')).bind(
			getShortcutString('openShortcutModal'),
			this.toggleShortcutModal
		)
	}

	componentWillUnmount() {
		Mousetrap(document.querySelector('body')).unbind(
			getShortcutString('openShortcutModal'),
			this.toggleShortcutModal
		)
	}

	onCreate = tippy => {
		this.tippy = tippy
	}

	closeTippy = () => {
		this.tippy.hide()
	}

	toggleShortcutModal = () => {
		const { shortcutModalOpen } = this.state

		this.setState({ shortcutModalOpen: !shortcutModalOpen })
	}

	render() {
		const { className, t, ...rest } = this.props

		const { shortcutModalOpen } = this.state

		return (
			<>
				<ShortcutModal
					visible={shortcutModalOpen}
					onClose={() => this.setState({ shortcutModalOpen: false })}
				/>

				<div className={className} {...rest}>
					<FlexContainer
						flexDirection="column"
						justifyContent="center"
						noSpaceBetweenChilds
					>
						<BrowserView renderWithFragment>
							<Button
								icon={<Icon name="shortcuts" />}
								onClick={() => {
									this.toggleShortcutModal()
								}}
							/>
						</BrowserView>
						<Tooltip
							placement="top-end"
							trigger="click"
							animation="shift-away"
							animateFill={false}
							theme="min-width-large"
							interactive
							onCreate={this.onCreate}
							content={
								<ButtonGroup>
									<BrowserView renderWithFragment>
										<Button
											text={t('shortcuts')}
											layout="tertiary"
											fullWidth
											size="small"
											icon={<Icon name="shortcuts" />}
											onClick={() => {
												this.toggleShortcutModal()
												this.closeTippy()
											}}
										/>
									</BrowserView>
									<Button
										text={t('tour')}
										layout="tertiary"
										fullWidth
										size="small"
										icon={<Icon name="tour" />}
										onClick={() => {
											this.closeTippy()

											history.push({ hash: '#tour' })
										}}
									/>
									<Button
										text={t('feedback')}
										layout="tertiary"
										fullWidth
										size="small"
										icon={<Icon name="feedback" />}
										onClick={this.closeTippy}
										href="https://feedback.skara.io/"
										target="_blank"
										rel="noopener noreferrer"
									/>
									<Button
										text={t('download_app')}
										layout="tertiary"
										fullWidth
										size="small"
										icon={<Icon name="apple" />}
										onClick={this.closeTippy}
										href="https://skara.io/desktop-apps/"
										target="_blank"
										rel="noopener noreferrer"
									/>
									<hr className="o-button-group__divider" />
									<Button
										text={t('privacy_policy')}
										layout="tertiary"
										fullWidth
										size="small"
										onClick={this.closeTippy}
										href="https://www.skara.io/privacy/"
										target="_blank"
										rel="noopener noreferrer"
									/>
									<Button
										text={t('legal_notice')}
										layout="tertiary"
										fullWidth
										size="small"
										onClick={this.closeTippy}
										href="https://www.skara.io/imprint/"
										target="_blank"
										rel="noopener noreferrer"
									/>
									<Button
										text={t('terms_of_service')}
										layout="tertiary"
										fullWidth
										size="small"
										onClick={this.closeTippy}
										href="https://www.skara.io/terms-of-service/"
										target="_blank"
										rel="noopener noreferrer"
									/>
								</ButtonGroup>
							}
						>
							<Button icon={<Icon name="help" />} />
						</Tooltip>
					</FlexContainer>
				</div>
			</>
		)
	}
}

PageFooterActions.propTypes = {
	className: PropTypes.string,
}

PageFooterActions.defaultProps = {
	className: null,
}

export default translate()(PageFooterActions)
